
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import HtmlEditor from "@/vue/components/HtmlEditor.vue";
    import { PasscodeToContinueOptions } from "@/model/pagePartOptions/PasscodeToContinueOptions";

    const whiteSpaceOrPunctRegex = /[\s\p{P}]/u;

    @Component({ components: { HtmlEditor } })
    export default class PasscodeToContinuePartEdit extends Vue {

        @Ref("editForm")
        readonly editForm!: VForm;

        @Prop({ required: true })
        pagePartOptions!: PasscodeToContinueOptions;

        validateCode(value: any): true|string {
            if(!value) return "Please supply a code";
            const code = String(value);
            if (code.length < 4) return "Supply at least 4 characters";
            if (code.length > 20) return "Should be less than 20 characters";
            if (whiteSpaceOrPunctRegex.test(code)) return "Should not contain any white space or punctuation";
            return true;
        }

        validate(): boolean {
            return this.editForm.validate();
        }
    }
